import type { CSSProperties, PointerEvent, ReactNode, Ref } from "react"

interface SiteSectionProps {
  id?: string
  children?: ReactNode
  borderBottom?: boolean
  fullWidth?: boolean
  height?: string
  innerClassName?: string
  innerRef?: Ref<HTMLDivElement>
  outerClassName?: string
  onPointerEnter?: (event: PointerEvent<HTMLDivElement>) => void
  onPointerLeave?: (event: PointerEvent<HTMLDivElement>) => void
  onPointerMove?: (event: PointerEvent<HTMLDivElement>) => void
}

export function SiteSection({
  id,
  children,
  borderBottom = true,
  fullWidth = false,
  height,
  innerClassName = "",
  innerRef,
  outerClassName = "",
  onPointerEnter,
  onPointerLeave,
  onPointerMove,
}: SiteSectionProps) {
  const fixedHeightClassName = height ? "site-section-fixed" : ""
  const widthClassName = fullWidth
    ? "w-full"
    : "mx-auto w-full max-w-320 border-subtle min-[1280px]:border-x"
  const sectionStyle = {
    ...(height ? { "--site-section-height": height } : {}),
  } as CSSProperties

  return (
    <section
      id={id}
      className={`${borderBottom ? "border-b border-subtle" : ""} ${outerClassName}`}
    >
      {/* Side borders only appear once the 1280px container has room to sit
          inside the viewport; below that they'd draw on the browser edges. */}
      <div
        ref={innerRef}
        className={`${fixedHeightClassName} ${widthClassName} ${innerClassName}`}
        onPointerEnter={onPointerEnter}
        onPointerLeave={onPointerLeave}
        onPointerMove={onPointerMove}
        style={sectionStyle}
      >
        {children}
      </div>
    </section>
  )
}
